<template>
    <div class="footer" :style="{color: style.color, fontSize: style.fontSize}">{{ style.text }}</div>
</template>

<script setup>
    import { ref } from 'vue';
    const style = ref(window.globalConfig.footerStyle);
</script>

<style scoped lang="scss">
    .footer {
        padding: 0 8px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 135px;
    }
</style>